import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function FeaturedArticles() {
  const featured = articles.slice(0, 3);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          热门推荐
        </h2>
        <p className="text-sm text-foreground-600 max-w-lg mx-auto">
          精选优质内容，看看大家都在读什么
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {featured.map((article, idx) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-200 transition-colors cursor-pointer"
            data-product-shop=""
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                title={`${article.title} - 17c一起草国`}
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                  {idx === 0 ? "精选" : idx === 1 ? "热门" : "推荐"}
                </span>
                <span className="text-xs text-foreground-500">{article.publishedAt}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-accent-500 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200/60">
                <span className="text-xs text-foreground-500">{article.author}</span>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {article.viewCount.toLocaleString()}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}